import React, { useEffect, useState } from "react";
import { accountLogAPI, getChildrenByEventId } from "../service/AuthService";
import {
  ClientWithdrawAndDepositAPI,
  getClientAPI,
} from "../service/UserService";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { useQuery } from "react-query";
import toast from "react-hot-toast";
import AsyncSelect from "react-select/async";

export default function DebitCreditEntry() {
  const [child, setChild] = useState([]);
  const userData = useSelector((state) => state.account.userData);
  const { userType } = useParams();
  const location = useLocation();
    const [selectedUser, setSelectedUser] = useState(
    location?.state?.userId
      ? {
        value: location?.state?.userId,
        label: location?.state?.userName,
      }
      : {
        value: "",
        label: "",
      }
  );
  

  
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [accountLogs, setAccountLog] = useState([]);

  const [payload, setPayload] = React.useState({
    pageSize: 50,
    pageNumber: 0,
    search: "",
    userName: selectedUser,
  });
  const [paymentPayload, setPaymentPayload] = useState({
    id: selectedUser,
    balance: 0,
    remarks: "",
    transactionType: "",
  });

  const accountLog = async (userName) => {
    try {
      const { response, code } = await accountLogAPI(
        {
          ...payload,
          userName: userName?.label.split(" ")[0],
        },
        location?.state?.isOld
      );
      if (code === 200) {
        setAccountLog(response);
      } else {
        // toast.error(response);
      }
    } catch {
      console.log("error");
    }
  };

  const getChild = async (username) => {
    const { response } = await getClientAPI(
      username ? username : payload.search,
      payload.pageNumber,
      payload.pageSize,
      "",
      userType?.toLocaleUpperCase(),
      false
    );
    setChild(response.childrenUserResponseDTOSPage?.content);
    return response.childrenUserResponseDTOSPage?.content?.map((item) => ({
      value: item.uid,
      label: `${item.username} ${item.name}`,
    }));
  };
  const submitData = async () => {
    const { response, code } = await ClientWithdrawAndDepositAPI(
      selectedUser?.value,
      paymentPayload
    );
    if (code === 200) {
      accountLog(selectedUser);
      toast.success("Transaction Success");
    }
  };
  useEffect(() => {
    getChild(
      location?.state?.userName?.split(" ")[0] || location?.state?.userName
    );
    if (selectedUser) {
      accountLog(selectedUser);
    }
    setAccountLog([]);
  }, [selectedUser, payload.pageNumber]);

  useEffect(() => {
    getChild();
    setAccountLog([]);
  }, [userType]);



  return (
    <div className="content-wrapper" style={{ minHeight: "1300.41px" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Cash Transaction</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active">Cash Transaction</li>
              </ol>
            </div>
          </div>
        </div>
        {/* /.container-fluid */}
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {/* /.card */}
              <div className="card">
                <div>
                  <div className="card-header ">
                    <h4 className="text-capitalize">{userType?.toLowerCase()} Ledger</h4>
                    <div className="form-row col-md-9">
                      <div className="form-group col-md-4">
                        <label htmlFor="name" className="text-capitalize">
                          client
                        </label>

                        <AsyncSelect
                          loadOptions={async (inputValue) => {
                            if (inputValue.length >= 2)
                              return getChild(inputValue);
                          }}
                          cacheOptions
                          defaultOptions={child?.map((item) => ({
                            value: item?.uid,
                            label: `${item?.username} ${item?.name}`,
                          }))}
                          defaultValue={
                            location?.state?.uid
                              ? {
                                value: location?.state?.uid,
                                label: location?.state?.username,
                              }
                              : null
                          }
                          value={selectedUser}
                          onChange={(selectedOption) => {
                            setSelectedUser(selectedOption);
                          }}
                        />
                      </div>

                      <div className="form-group col-md-4">
                        <label htmlFor="amount">Amount</label>
                        <input
                          type="number"
                          className="form-control "
                          defaultValue=""
                          step="any"
                          id="amount"
                          onChange={(e) => {
                            setPaymentPayload({
                              ...paymentPayload,
                              balance: e.target.value,
                            });
                          }}
                          placeholder="Amount"
                          name="amount"
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label htmlFor="type">Payment Type</label>
                        <select
                          className="form-control custom-select"
                          required=""
                          id="type"
                          name="paymentType"
                          onChange={(e) => {
                            setPaymentPayload({
                              ...paymentPayload,
                              transactionType: e.target.value,
                            });
                          }}
                        >
                          <option value={""}>Select payment type</option>
                          <option
                            value={userType == "client" ? "WITHDRAW" : "DEPOSIT"}
                          >
                            PAYMENT - DENA
                          </option>
                          <option
                            value={userType == "client" ? "DEPOSIT" : "WITHDRAW"}
                          >
                            RECEIPT - LENA
                          </option>
                        </select>
                      </div>
                      <div className="form-group col-md-4">
                        <label htmlFor="remark">Remark</label>
                        <input
                          type="text"
                          className="form-control "
                          id="remark"
                          onChange={(e) => {
                            setPaymentPayload({
                              ...paymentPayload,
                              remarks: e.target.value,
                            });
                          }}
                          placeholder="Remark"
                          name="remark"
                          defaultValue=""
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label
                          className="control-label text-purple"
                          htmlFor="btn"
                        >
                          `
                        </label>
                        <input
                          type="submit"
                          className="form-control btn-primary"
                          id="btn"
                          name="submit"
                          onClick={submitData}
                          defaultValue="Sumbit"
                        />
                      </div>
                    </div>
                  </div>
                  {/* /.card-header */}
                  <div className="card-body">
                    {accountLogs?.length == 0 ? (
                      <div className="alert alert-warning">
                        <h6>No Record Found</h6>
                      </div>
                    ) : (
                      // <div className="card-body">
                        <table
                          id="example1"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>SNo.</th>
                              <th>Date</th>
                              <th>Collection Name</th>
                              <th>Debit</th>
                              <th>Credit</th>
                              <th>Balance</th>
                              <th>Payment Type</th>
                              <th>Remark</th>
                              {/* <th>Description</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="tbody-color">
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>
                                <strong className={`${accountLogs[0]?.updatedBalance > 0
                                  ? "text-blue"
                                  : "text-red"
                                  } `}>
                                  Total Amount
                                </strong>
                              </td>
                              {userType == "client" ? (
                                <td className="text-lg">
                                  {parseFloat(
                                    accountLogs?.reduce(
                                      (acc, item) => acc + item.creditInfo,
                                      0
                                    )
                                  ).toFixed(2)}
                                </td>
                              ) : (
                                <td className="text-lg">
                                  {parseFloat(
                                    accountLogs?.reduce(
                                      (acc, item) => acc + item.debitInfo,
                                      0
                                    )
                                  ).toFixed(2)}
                                </td>
                              )}
                              {userType == "client" ? (
                                <td className="text-lg">
                                  {parseFloat(
                                    accountLogs?.reduce(
                                      (acc, item) => acc + item.debitInfo,
                                      0
                                    )
                                  ).toFixed(2)}
                                </td>
                              ) : (
                                <td className="text-lg">
                                  {parseFloat(
                                    accountLogs?.reduce(
                                      (acc, item) => acc + item.creditInfo,
                                      0
                                    )
                                  ).toFixed(2)}
                                </td>
                              )}
                              <td
                                className={`text-lg ${accountLogs[0]?.updatedBalance > 0
                                  ? "text-blue"
                                  : "text-red"
                                  } `}
                              >
                                {parseFloat(accountLogs[0]?.updatedBalance).toFixed(2)}
                              </td>
                              <td>&nbsp;</td>
                            </tr>
                            {accountLogs?.length > 0 ? (
                              accountLogs
                                ?.sort(
                                  (a, b) =>
                                    new Date(b.createdAt) - new Date(a.createdAt)
                                )
                                ?.map((item, index) => (
                                  <tr

                                    className="ng-star-inserted"
                                  >
                                    <td>{index + 1}</td>
                                    <td>
                                      <div

                                        className="Date_time_box"
                                      >
                                        {moment(item?.createdAt + "Z").format(
                                          "DD-MM-YYYY HH:mm"
                                        )}
                                      </div>
                                    </td>
                                    <td>C1CASH</td>
                                    <td

                                      className={
                                        userType == "client"
                                          ? item.creditInfo >= 0
                                            ? "plus_value"
                                            : "mainus_value"
                                          : item.debitInfo >= 0
                                            ? "plus_value"
                                            : "mainus_value"
                                      }
                                    >
                                      {userType == "client"
                                        ? parseFloat(item.creditInfo).toFixed(2)
                                        : parseFloat(item.debitInfo).toFixed(2)}
                                    </td>
                                    <td

                                      className={
                                        userType == "client"
                                          ? item.creditInfo >= 0
                                            ? "plus_value"
                                            : "mainus_value"
                                          : item.debitInfo >= 0
                                            ? "plus_value"
                                            : "mainus_value"
                                      }
                                    >
                                      {userType == "client"
                                        ? parseFloat(item.debitInfo).toFixed(2)
                                        : parseFloat(item.creditInfo).toFixed(2)}
                                    </td>
                                    <td

                                      className={
                                        item.updatedBalance > 0
                                          ? "plus_value"
                                          : "mainus_value"
                                      }
                                    >
                                      <strong>
                                        {parseFloat(item.updatedBalance).toFixed(2)}
                                      </strong>
                                    </td>

                                    <td>

                                      {item?.type == "BALANCE_REPORT"
                                        ? userType?.toUpperCase() == "CLIENT"
                                          ? item?.debitInfo != 0
                                            ? "/PAYMENT DIYA"
                                            : "/PAYMENT LIYA"
                                          : item?.debitInfo != 0
                                            ? "/PAYMENT LIYA"
                                            : "/PAYMENT DIYA"
                                        : ""}
                                    </td>

                                    {/* {item.type == "BALANCE_REPORT" ? (
                                      <td>
                                        {userType == "client" ? <>
                                          {item.debitInfo ? "DIYA HAI" : "LIYA HAI"}
                                        </> : <>{item.debitInfo ? "LIYA HAI" : "DIYA HAI"}</>}
                                      </td>
                                    ) : (
                                      <td />
                                    )} */}

                                    <td>{item.comment}</td>
                                  </tr>
                                ))
                            ) : (
                              <tbody>
                                <tr hidden="">
                                  <td

                                    colSpan={6}
                                    style={{ textAlign: "center" }}
                                  >
                                    No Matches Available !
                                  </td>
                                </tr>
                              </tbody>
                            )}
                          </tbody>
                          <tfoot />
                        </table>
                      // </div>
                    )}
                  </div>
                  {/* /.card-body */}
                </div>
              </div>
              {/* /.card */}
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container-fluid */}
      </section>
    </div>
  );
}
